<template>
  <div class="recover-box">
    <div>
        <a-button v-if="coupon.usageStatus === '0'" @click="handleUseClick">Use</a-button>
        <a-popconfirm
            v-if="coupon.usageStatus === '1'"
            title="Are you sure recover this coupon?"
            ok-text="Yes"
            cancel-text="No"
            @confirm="handleRecoverClick"
        >
            <a-button>Recover</a-button>
        </a-popconfirm>
    </div>
    <a-modal
      title="Use Coupon"
      :visible="showUserCoupon"
      @cancel="() => { this.showUserCoupon = false }"
      @ok="() => handleUseOk()"
    >
        <a-form-model
            ref="useForm"
            v-if="useCoupon"
            :model="useCoupon"
            :rules="formRules"
        >
            <a-form-model-item prop="bookingNumber" label="Booking Number">
                <a-input v-model="useCoupon.bookingNumber" />
            </a-form-model-item>
            <a-form-model-item prop="usageTime" label="Usage Date">
                <a-date-picker
                    v-model="useCoupon.usageTime"
                    type="date"
                    placeholder="Pick a date"
                    style="width: 100%;"
                />
            </a-form-model-item>
        </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import CouponApi from '@/api/api-cdb-membership-coupon'

export default {
  name: 'CouponRecover',
  props: {
    coupon: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
        showUserCoupon: false,
        useCoupon: null,
        // 表单校验规则
        formRules: {
            bookingNumber: [ { required: true } ],
            usageTime: [ { required: true } ]
        }
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData () {
    },
    // 处理点击恢复
    async handleRecoverClick () {
        try {
            const res = await CouponApi.recoverCoupon(this.coupon.couponNumber)
            if (!this.mixinProcessHasBizErrorNotification(res)) {
                this.mixinProcessSuccessNotification('success!')
                const newCoupon = this.copyDataByJSON(this.coupon)
                newCoupon.usageStatus = '0'
                newCoupon.usageTime = null
                newCoupon.bookingNumber = null
                this.$emit('couponChange', newCoupon)
            }
        } catch (e) {
            console.log(e)
        }
    },
    // 处理点击使用
    handleUseClick () {
        this.showUserCoupon = true
        this.useCoupon = { bookingNumber: '', usageTime: '' }
    },
    // 处理点击使用表单Ok
    async handleUseOk () {
        try {
            const validResult = await this.$refs.useForm.validate()
            if (!validResult) {
                return
            }
            const usageTime = this.useCoupon.usageTime.format('YYYY-MM-DD 00:00:00')
            const bookingNumber = this.useCoupon.bookingNumber
            const res = await CouponApi.useCoupon(this.coupon.couponNumber, bookingNumber, usageTime)
            if (!this.mixinProcessHasBizErrorNotification(res)) {
                this.mixinProcessSuccessNotification('success!')
                const newCoupon = this.copyDataByJSON(this.coupon)
                newCoupon.usageStatus = '1'
                newCoupon.usageTime = usageTime
                newCoupon.bookingNumber = bookingNumber
                this.$emit('couponChange', newCoupon)
            }
            this.showUserCoupon = false
            this.useCoupon = null
        } catch (e) {
            console.log(e)
        }
    }
  }
}
</script>

<style scoped>
::v-deep .ant-form-item{
  margin-bottom: 0;
}
::v-deep .ant-modal-body {
  padding: 10px 24px;
}
</style>